import React, { memo, useMemo } from 'react'
import { useField } from 'formik'
import { BasicSelect } from 'src/components/shared/form/BasicSelect'
import type { BasicSelectOption } from 'src/components/shared/form/BasicSelect'

interface Props {
  /** A FieldArray path, e.g. `rows[2].type`. */
  name: string
  label?: string
  options: BasicSelectOption[]
  placeholder?: string
  disabled: boolean
}

const VendorFeeSelectFieldComponent = ({ name, label, options, placeholder, disabled }: Props) => {
  const [field, meta] = useField<string>(name)

  /**
   * The backend period enum has a sixth member (`custom`) this app never offers. A row already
   * stored as one must still render and round-trip, so an unrecognised persisted value is
   * appended as its own option rather than silently falling back to the first entry — which
   * would rewrite live pricing the admin never touched.
   */
  const renderedOptions = useMemo(() => {
    const isKnown = options.some((option) => {
      return option.value === field.value
    })

    if (isKnown || !field.value) {
      return options
    }

    return [...options, { label: field.value, value: field.value }]
  }, [options, field.value])

  return (
    <BasicSelect
      name={name}
      label={label}
      value={field.value}
      options={renderedOptions}
      placeholder={placeholder}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      disabled={disabled}
      onChange={field.onChange}
      onBlur={field.onBlur}
    />
  )
}

export const VendorFeeSelectField = memo(VendorFeeSelectFieldComponent)
